import KeyboardArrowLeftRoundedIcon from "@mui/icons-material/KeyboardArrowLeftRounded";
import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded";
import { Box, IconButton, lighten } from "@mui/material";

interface Props {
  variant: "expand" | "collapse";
  paddingTop: number | undefined;
  panelSide?: "left" | "right";
  onClick: () => void;
}

export const ExpandCollapseButton = (props: Props) => {
  const { variant, paddingTop, panelSide, onClick } = props;
  const pointsLeft = panelSide === "right" ? variant === "expand" : variant === "collapse";

  return (
    <Box sx={{ position: "relative", zIndex: 2 }}>
      <Box sx={{ position: "absolute" }}>
        <IconButton
          sx={(theme) => ({
            border: `1px solid ${theme.palette.divider}`,
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.secondary.light,
            p: 0,
            top: paddingTop ?? "17px",
            right: panelSide === "right" ? "17px" : "14px",
            "&:hover": {
              borderColor: lighten(theme.palette.primary.main, 0.5),
              color: theme.palette.primary.main,
              backgroundColor: lighten(theme.palette.primary.main, 0.8),
            },
          })}
          onClick={onClick}
        >
          {pointsLeft ? (
            <KeyboardArrowLeftRoundedIcon fontSize="medium" />
          ) : (
            <KeyboardArrowRightRoundedIcon fontSize="medium" />
          )}
        </IconButton>
      </Box>
    </Box>
  );
};

export default ExpandCollapseButton;
